import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import FormField from "../../../../components/common/FormField";
import { siteType, storageTypes } from "../../storageComponent";
const FILTER_FIELDS = [
  {
    id: "siteType",
    label: "Site Type",
    placeHolder: "Select Site Type",
    type: "select",
    options: [...siteType],
  },
  {
    id: "storageType",
    label: "Storage Type",
    placeHolder: "Select Storage Type",
    type: "select",
    options: [...storageTypes],
  },
];

interface StorageFilterData {
  siteType: string;
  storageType: string;
}

interface ManageStorageFilterProps {
  open: boolean;
  onHide: () => void;
  title: string;
  filterData: StorageFilterData;
  onApply: (data: StorageFilterData) => void;
  onClear: () => void;
}



const ManageStorageFilter: React.FC<ManageStorageFilterProps> = ({
  open,
  onHide,
  title,
  filterData,
  onApply,
  onClear,
}) => {
  const [formData, setFormData] = useState<StorageFilterData>({
    siteType: "",
    storageType: "",
  });

  useEffect(() => {
    if (open) {
      setFormData({
        siteType: filterData?.siteType || "",
        storageType: filterData?.storageType || "",
      });
    }
  }, [open, filterData]);

  const onChangeAction = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const hideHandler = () => {
    onHide();
  };

  const clearHandler = () => {
    const clearedData: StorageFilterData = {
      siteType: "",
      storageType: "",
    };

    setFormData(clearedData);

    // Send clear action to SiteList
    onClear();

    onHide();
  };

  const submitHandler = () => {
    // Send selected filters to SiteList
    onApply(formData);

    onHide();
  };

  return (
    <Popup
      open={open}
      title={title}
      onHide={hideHandler}
      fullWidth
      maxWidth="sm"
      popupBg="#fff"
      footer={
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 2,
            marginTop:'16px'
          }}
        >
          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            variant="outlined"
            title="Clear"
            onClick={clearHandler}
          />

          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            variant="outlined"
            title="Cancel"
            onClick={hideHandler}
          />

          <CustomButton
            style={{
              padding: "10px 30px",
              height: "36px",
            }}
            title="Apply"
            onClick={submitHandler}
          />
        </Box>
      }
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{
          marginTop: 3,
          padding: "0px 8px",
        }}
      >
        {FILTER_FIELDS.map((field) => (
          <Grid item xs={6} key={field.id}>
            <FormField
              onPaste={(e: React.ClipboardEvent) => e.preventDefault()}
              {...field}
              value={formData?.[field.id as keyof StorageFilterData] || ""}
              onChange={onChangeAction}
              isNonMarginTop
              inSingleGridForm
              InputProps={{
                sx: {
                  padding: "10px 4px",
                  height: "36px",
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Popup>
  );
};

export default ManageStorageFilter;